import React, { useEffect, useState } from 'react';
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';
import { useHook as equipmentHook } from './useHook';
import { useParams } from 'react-router-dom';
import { useAlert } from '../../../components/Notification';
import { closeIcon } from '../../../assets/images/index';
import { Unauthorized } from '../../../components';
interface WritableParameterListProps {
  equipmentDetailsData: any;
  equipmentPage: string;
  refreshKey?: any;
}

const WritableParameterList: React.FC<WritableParameterListProps> = ({
  equipmentDetailsData,
  equipmentPage,
  refreshKey,
}) => {
  const { fetchWriteUnitParameterValue, updateWriteParameter } =
    equipmentHook();
  const { id } = useParams();
  const [parameterValue, setParameterValue] = useState('');
  const [ParameterList, setParameterList] = useState<any[]>([]);
  const [editParamAccess, setEditParamAccess] = useState(false);
  const [writableValue, setWritableValue] = useState<any>({});
  // const [errorRange, setErrorRange] = useState('');
  const showAlert = useAlert();

  useEffect(() => {
    if (equipmentDetailsData) {
      setParameterList(equipmentDetailsData?.writableParameters || []);
    }
    if (equipmentPage) {
      setEditParamAccess(
        equipmentDetailsData?.equipmentAccess === 'WRITE' ||
          equipmentPage !== 'sharedwithme',
      );
    }
  }, [equipmentDetailsData, equipmentPage]);
  //Get WritaleParam List
  const getWritableParameterList = async () => {
    await fetchWriteUnitParameterValue({ unitID: id })
      .then((response) => {
        setWritableValue(response);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getWritableParameterList();
  }, [refreshKey]);

  //exite submit param
  const handleCancelParam = () => {
    setParameterList(equipmentDetailsData?.writableParameters || []);
  };

  //submit param
  const handleSubmit = async (data: any) => {
    const payload = {
      unitID: id,
      variableName: data.variableName,
      variableValue: Number(parameterValue),
    };

    if (
      Number(parameterValue) < data.minValue ||
      Number(parameterValue) > data.maxValue
    ) {
      showAlert(
        `Parameter value is out of range. Please select between ${data.minValue} - ${data.maxValue}`,
        'error',
      );
    } else if (
      countDecimalPlaces(Number(parameterValue)) > Number(data.decimals)
    ) {
      showAlert(`Only ${data.decimals} decimal points are allowed`, 'error');
    } else {
      await updateWriteParameter(payload).then((res) => {
        setParameterList(equipmentDetailsData?.writableParameters || []);
        getWritableParameterList();
      });
    }
  };

  const countDecimalPlaces = (decimalval: any) => {
    const str = decimalval.toString();
    if (str.includes('.')) {
      return str.split('.')[1].length;
    }
    return 0;
  };

  //Update Writable Value
  const handleUpdateWritableValue = (data: any, index: number) => {
    const upDateWritableList = ParameterList?.map((param, i) => {
      return index === i
        ? { ...param, editInput: true }
        : { ...param, editInput: false };
    });
    setParameterValue(
      writableValue?.[data?.variableName]?.toFixed(data?.decimals) || '',
    );
    setParameterList(upDateWritableList);
  };

  const renderComponent = () => {
    if (Object.keys(equipmentDetailsData).length > 0) {
      return ParameterList?.length > 0 ? (
        <section className="equipment_information">
          <h5>Writable Parameter List</h5>

          {equipmentDetailsData?.subscriptionStatus === 'active' ? (
            <>
              {!editParamAccess && (
                <p className="edit_access_error">
                  * You cannot edit Parameter Value. Please contact to your
                  admin partner.
                </p>
              )}
              <div className="equipment_information-content">
                <TableContainer
                  className="dashboard_table-container parameter_list_table-container"
                  component={Paper}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell className="parameter_list_table-heading">
                          Parameter Name
                        </TableCell>
                        <TableCell className="parameter_list_table-heading">
                          Value
                        </TableCell>
                        {editParamAccess && <TableCell></TableCell>}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {ParameterList?.map((data: any, index: number) => (
                        <TableRow key={index}>
                          <TableCell>{data?.parameterName}</TableCell>
                          <TableCell
                            className={
                              data?.editInput && 'parameter_list-input_field'
                            }
                          >
                            {data?.editInput ? (
                              <TextField
                                type="number"
                                fullWidth
                                value={parameterValue}
                                onChange={(e) =>
                                  setParameterValue(e.target.value)
                                }
                                InputLabelProps={{ shrink: true }}
                              />
                            ) : (
                              <>
                                <span>
                                  {' '}
                                  {writableValue?.[data?.variableName]?.toFixed(
                                    data?.decimals,
                                  ) ||
                                    data?.defaultValue?.toFixed(
                                      data?.decimals,
                                    )}{' '}
                                </span>
                                <span> {data?.unit || ''}</span>
                              </>
                            )}
                          </TableCell>
                          {editParamAccess && (
                            <TableCell
                              className={
                                data?.editInput
                                  ? ' parameter_list-action_field'
                                  : 'customer_management-action'
                              }
                            >
                              {data?.editInput ? (
                                <div className="writableparam_btn_container">
                                  <Button
                                    className={
                                      parameterValue
                                        ? 'parameter_list-action_active'
                                        : 'parameter_list-action_disabled'
                                    }
                                    disabled={!parameterValue}
                                    onClick={() => handleSubmit(data)}
                                  >
                                    Save
                                  </Button>
                                  <Button
                                    onClick={handleCancelParam}
                                    className="writable_cancel-btn"
                                  >
                                    <img
                                      src={closeIcon}
                                      alt="Delete Icon"
                                      width={13}
                                    />
                                  </Button>
                                </div>
                              ) : (
                                <div className="form-action-btn">
                                  <Button
                                    className="btn-transparent border-0 img-background-form"
                                    onClick={() =>
                                      handleUpdateWritableValue(data, index)
                                    }
                                  >
                                    <i className="edit-icon bi bi-pencil-square bi-lg"></i>
                                  </Button>
                                </div>
                              )}
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                      {/* {editParamAccess && (
                    <TableRow>
                      <TableCell>
                        Parameter Name {ParameterList?.length + 1}{' '}
                      </TableCell>
                      <TableCell className="parameter_list-input_field">
                        <TextField
                          type="number"
                          fullWidth
                          value={parameterValue}
                          onChange={(e) => setParameterValue(e.target.value)}
                          InputLabelProps={{ shrink: true }}
                        />
                      </TableCell>
                      <TableCell className="parameter_list-action_field">
                        <Button
                          className={
                            parameterValue
                              ? 'parameter_list-action_active'
                              : 'parameter_list-action_disabled'
                          }
                          disabled={!parameterValue}
                          onClick={() =>
                            handleSubmit({
                              name: `Parameter Name ${ParameterList?.length + 1}`,
                              value: parameterValue,
                            })
                          }
                        >
                          Save
                        </Button>
                      </TableCell>
                    </TableRow>
                  )} */}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </>
          ) : (
            // <p className="edit_access_error">
            //   * You cannot view parameter value . Please contact to your admin
            //   partner.
            // </p>
            <Unauthorized
              message={
                'Your subscription is inactive. Please activate it to view the details.'
              }
            />
          )}
        </section>
      ) : (
        <></>
      );
    } else {
      return <></>;
    }
  };

  return renderComponent();
};

export default WritableParameterList;
